import { request } from '@/api';
import type { PaginationData } from '@/types/api';
import type {
  CreateUploadTaskDto,
  CreateUploadTaskResp,
  RetryUploadTaskDto,
  RetryUploadTaskResp,
  UpdateUploadTaskStatusDto,
  UpdateUploadTaskStatusResp,
  UploadTaskApi,
  UploadTaskDetailResp,
  UploadTaskPageDto,
  UploadTaskRecord,
} from './uploadTask.types';

export type * from './uploadTask.types';
// 枚举是「值」，`export type *` 不会带出去，这里显式再导一次，页面直接用常量而不是魔法数
export { UPLOAD_TASK_ITEM_STATUS, UPLOAD_TASK_STATUS, UPLOAD_TASK_TYPE } from './uploadTask.types';

/** 接口根路径（网关前缀 `/creative`） */
const BASE = '/creative/upload/task';

/**
 * 上传任务接口的真实实现。
 *
 * 注意：`taskId` / `itemId` 等唯一标识一律按 **string** 处理，
 * 后端返回 number 时由 axios 原样透传字符串化结果，前端**不做 Number() 转换**（避免雪花 ID 丢精度）。
 */
export const uploadTaskApi: UploadTaskApi = {
  create: (data: CreateUploadTaskDto) => request.post<CreateUploadTaskResp>(`${BASE}/create`, data),
  page: (data: UploadTaskPageDto) =>
    request.post<PaginationData<UploadTaskRecord>>(`${BASE}/page`, data),
  detail: (taskId: string) => request.get<UploadTaskDetailResp>(`${BASE}/detail/${taskId}`),
  updateStatus: (data: UpdateUploadTaskStatusDto) =>
    request.post<UpdateUploadTaskStatusResp>(`${BASE}/status/update`, data),
  retry: (data: RetryUploadTaskDto) => request.post<RetryUploadTaskResp>(`${BASE}/retry`, data),
};

